'use client';

import {useCallback} from 'react';

import {StrapiArticle} from '@web-catalog/types';

import {logTmrEvent} from '@web-catalog/utils/analytics';

import styles from './ArticleCard.module.scss';

type Props = {
  article: StrapiArticle;
  blockName: string;
  className?: string;
};

export const ArticleCard = ({article, className, blockName}: Props) => {
  const onClick = useCallback(() => {
    logTmrEvent({
      logEvent: 'article.click',
      params: {
        article_name: article.attributes.cardTitle,
        compilation_name: blockName,
      },
    });
  }, [article, blockName]);

  return (
    <a
      href={`/prostore/${article.attributes.href}`}
      className={className}
      target="_blank"
      rel="noreferrer noopener"
      onClick={onClick}
    >
      <div className={styles.root}>
        <div className={styles.backgroundImageContainer}>
          <img
            src={article.attributes.cardBackgroundImage.data.attributes.url}
            className={styles.backgroundImage}
            loading="lazy"
            alt={`Обложка статьи ${article.attributes.cardTitle}`}
          />
        </div>
        <div className={styles.title}>{article.attributes.cardTitle}</div>
      </div>
    </a>
  );
};
